var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("filtros-letty", {
        attrs: {
          filtersView: _vm.filterView,
          "has-query-filters": !!_vm.queryFilters,
          "clear-query-filters": _vm.clear
        },
        on: { "filtros-aplicados": _vm.changeFilters }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }